import { Layout } from '../layout'
import { ModuleLoader } from '../module_loader/module_loader'
import React from 'react'
const MusicSubmission = React.lazy(() => import('./music_submission'))

const display = () => {
  return (
    <Layout>
      <ModuleLoader>
        <MusicSubmission />
      </ModuleLoader>
    </Layout>
  )
}

export { display as MusicSubmissionDisplay }
export { MusicSubmission }

export default MusicSubmission
